export default {
    reservedAccount: { loading: true },
    createReserve: { loading: false },
    reservedAccountsDetails: { loading: true },
    dashboardBankAccounts: { loading: true },
    ReservedAccountPayouts: { loading: true }
};
